import type { InputHTMLAttributes } from "react";

type Size = "medium" | "small";

const SIZES: Record<Size, { w: number; h: number; knob: number; pad: number }> = {
  medium: { w: 52, h: 32, knob: 24, pad: 4 },
  small: { w: 40, h: 24, knob: 18, pad: 3 },
};

export interface SwitchProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "type" | "size"> {
  checked?: boolean;
  disabled?: boolean;
  size?: Size;
}

export function Switch({ checked = false, disabled = false, size = "medium", onChange, style, ...rest }: SwitchProps) {
  const s = SIZES[size] || SIZES.medium;
  return (
    <label
      style={{
        display: "inline-flex",
        alignItems: "center",
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.4 : 1,
        ...style,
      }}
    >
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        style={{ position: "absolute", opacity: 0, width: 0, height: 0 }}
        {...rest}
      />
      <span
        style={{
          position: "relative",
          width: s.w,
          height: s.h,
          borderRadius: "var(--radius-full)",
          background: checked ? "var(--primary-normal)" : "var(--fill-strong)",
          transition: "background var(--duration-normal) var(--ease-standard)",
        }}
      >
        <span
          style={{
            position: "absolute",
            top: s.pad,
            left: checked ? s.w - s.knob - s.pad : s.pad,
            width: s.knob,
            height: s.knob,
            borderRadius: "var(--radius-full)",
            background: "var(--static-white)",
            boxShadow: "var(--shadow-normal)",
            transition: "left var(--duration-normal) var(--ease-emphasize)",
          }}
        />
      </span>
    </label>
  );
}

export default Switch;
